import Vue from "vue";
import Vuex from "vuex";
import message from "./modules/message";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    message,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js